import type { Point } from './model';

export function pointInRing(point: Point, ring: Point[]) {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [yi, xi] = ring[i], [yj, xj] = ring[j];
    if ((yi > point[0]) !== (yj > point[0])) {
      const crossing = ((xj - xi) * (point[0] - yi)) / (yj - yi) + xi;
      if (point[1] < crossing) inside = !inside;
    }
  }
  return inside;
}

export function pointInBoundary(point: Point, boundary?: Point[][]) {
  return !boundary?.length || boundary.some((ring) => pointInRing(point, ring));
}

export function pointInArea(
  point: Point,
  area: { center: Point; radiusKm: number; boundary?: Point[][] },
  distance: (a: Point, b: Point) => number,
) {
  return area.boundary?.length
    ? pointInBoundary(point, area.boundary)
    : distance(point, area.center) <= area.radiusKm;
}

